declare global {
  interface Window {
    __PRUI_RUNTIME__?: Record<string, string>;
  }
}

/** Populated by run-prui.sh from BASE_DEPLOY_DIR/.env (default /opt/prui/.env, sibling of /opt/prui/app) or PRUI_ENV_FILE; falls back to build-time env in dev. */
export function runtimeEnv(key: string): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const v = window.__PRUI_RUNTIME__?.[key];
  return v !== undefined && v !== '' ? v : undefined;
}

export function runtimeFlag(key: string): boolean {
  const v = (runtimeEnv(key) ?? '').toLowerCase();
  return v === 'true' || v === '1' || v === 'yes';
}
